// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuestionRubricSolution-module__container {
  position: relative;
}

.QuestionRubricSolution-module__visible {
  display: block;
}

.QuestionRubricSolution-module__hidden {
  visibility: hidden;
  height: 0;
  overflow: hidden;
  position: absolute;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/questionrubricsolution/QuestionRubricSolution.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB","sourcesContent":[".container {\n  position: relative;\n}\n\n.visible {\n  display: block;\n}\n\n.hidden {\n  visibility: hidden;\n  height: 0;\n  overflow: hidden;\n  position: absolute;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `QuestionRubricSolution-module__container`,
	"visible": `QuestionRubricSolution-module__visible`,
	"hidden": `QuestionRubricSolution-module__hidden`
};
export default ___CSS_LOADER_EXPORT___;
